<template>
  <div id="app">
    <router-view :key="$route.path" />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

::-webkit-scrollbar-track {
    background: #eee;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 0px;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p {
  margin: 0px !important;
  padding: 0px !important;
  font-size: 14px !important;
}

.btn-cp {
  background: #398ccc !important;
  color: white !important;
}

.btn-cp:hover {
  background: #195d91 !important;
}

.btn-info-cp {
  background: #3bced8 !important;
  color: white !important;
}

.btn-info-cp:hover {
  background: #27a8b1 !important;
}

.btn-link-cp {
  background: white !important;
  color: #398ccc !important;
}

.th-sortable {
  cursor: pointer !important;
}

.card-cp {
  max-width: 500px !important;
  width: 100% !important;
}

#content-wrap {
  position: relative;
  min-height: 100vh;
}

.container {
  padding-bottom: 100px;
}
</style>
